module.exports = __webpack_public_path__ + "static/img/penny.69b022a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/penny.png
// module id = oW4z
// module chunks = 0